import { createFileRoute, Outlet } from '@tanstack/react-router';
import { GraduationCap } from 'lucide-react';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/training')({
    staticData: {
        breadcrumb: {
            title: 'Training',
            inactive: true,
        },
        modules: ['compliance'],
        permissions: ['settings:update'],
        ui: {
            icon: GraduationCap,
            title: 'Training',
            useTitleForChildren: true,
            menuDescription: 'Training periods and custom fields',
        },
    },
    component: Outlet,
});
